import axios from "axios"
import { getDeviceId } from "lib/Cookies"

const getDeviceName = () => {
  const userAgent = navigator.userAgent
  const devices = {
    "Generic Linux": /Linux/i,
    Android: /Android/i,
    BlackBerry: /BlackBerry/i,
    Bluebird: /EF500/i,
    "Chrome OS": /CrOS/i,
    Datalogic: /DL-AXIS/i,
    Honeywell: /CT50/i,
    iPad: /iPad/i,
    iPhone: /iPhone/i,
    iPod: /iPod/i,
    macOS: /Macintosh/i,
    Windows: /IEMobile|Windows/i,
    Zebra: /TC70|TC55/i
  }
  const device = Object.keys(devices).find((name) => devices[name].test(userAgent)) || "Unknown"

  let browser = "unknown"
  if (userAgent.includes("Opera") || userAgent.includes("OPR")) browser = "Opera"
  else if (userAgent.includes("Edg")) browser = "Edge"
  else if (userAgent.includes("Chrome")) browser = "Chrome"
  else if (userAgent.includes("Safari")) browser = "Safari"
  else if (userAgent.includes("Firefox")) browser = "Firefox"
  else if (userAgent.includes("MSIE") || document.documentMode) browser = "IE"

  return `${device} ${browser}`
}

export const getAuthHeaders = () => ({
  Accept: "application/json",
  "Content-Type": "application/json",
  DevicePlatform: 1,
  DeviceName: getDeviceName(),
  TokenDevice: getDeviceId()
})

export const loginWithPassword = async ({ phone, password }) => {
  const response = await axios.post(
    `${process.env.NEXT_PUBLIC_DOMAIN_AUTH}/api/login`,
    { name: phone, password },
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const loginWithProvider = async ({ providerName, providerAccessToken }) => {
  const body = {
    provider_name: providerName,
    provider_access_token: providerAccessToken
  }

  const response = await axios.post(`${process.env.NEXT_PUBLIC_DOMAIN_AUTH}/api/login`, body, {
    headers: getAuthHeaders()
  })
  return response.data
}

export const kickoutDevice = async (uuid) => {
  const response = await axios.post(
    `${process.env.NEXT_PUBLIC_DOMAIN_AUTH}/api/v2/kickout_device`,
    { uuid },
    { headers: getAuthHeaders() }
  )
  return response.data
}

export const getAuthError = (error) => {
  const response = error?.response?.data || {}
  return {
    errorCode: response.error_code,
    message: response.error_message || error?.message || "Hệ thống bị gián đoạn xin vui lòng thử lại sau",
    data: response.data
  }
}
